module.exports = __webpack_public_path__ + "img/glogo218.672bff82.png";